// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Button} from '../../../../hola/pub/lib/button';
import Svg_pc from '../../img/dashboard/pc.svg';
import cn from 'classnames';
import styles from './no_account.module.less';

export const No_account = ({auth})=>{
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    return <div className={cn(styles.empty_block, styles.empty_account)}>
      <Svg_pc width={120} height={140}/>
      <div className={styles.text_wrapper}>
      <p className={cn(theme.p2, theme.med, theme.color_n700)}>
        <T>You don't have an account yet</T></p>
      <p className={cn(theme.p3)}>
        <T>No credit card needed until you've used your 5 free Proxies!
        </T>
      </p>
      <Button caption={t('Sign up')} color={'black'} size={'sm'}
        round={false} on_click={()=>auth('signup')}
        cls={styles.mb16}/>
      </div>
      <p className={cn(theme.p3)}><T>Already have an
        account?</T> <a onClick={()=>auth('login')}><T>Login</T></a></p>
    </div>;
};
